/**
 * <kj-popup delay="8"> wraps a <dialog>. Opens once per visitor after `delay` seconds
 * or on exit intent (pointer leaving the top of the window on desktop).
 * Remembers dismissal in localStorage for 14 days. Reopens after a newsletter submit to show the result.
 */
class KjPopup extends HTMLElement {
  static KEY = 'kj-popup-dismissed';
  #timer = 0;

  #onExit = (event) => {
    if (event.clientY <= 0 && !event.relatedTarget) this.#open();
  };

  connectedCallback() {
    const dialog = this.querySelector('dialog');
    if (!dialog) return;
    dialog.addEventListener('close', () => this.#remember());
    if (this.hasAttribute('posted')) {
      dialog.showModal();
      return;
    }
    if (this.#dismissed()) return;
    const delay = Number(this.getAttribute('delay') || 8) * 1000;
    this.#timer = window.setTimeout(() => this.#open(), delay);
    document.documentElement.addEventListener('mouseleave', this.#onExit);
  }

  disconnectedCallback() {
    window.clearTimeout(this.#timer);
    document.documentElement.removeEventListener('mouseleave', this.#onExit);
  }

  #open() {
    const dialog = this.querySelector('dialog');
    if (!dialog || dialog.open || this.#dismissed() || document.querySelector('dialog[open]')) return;
    window.clearTimeout(this.#timer);
    document.documentElement.removeEventListener('mouseleave', this.#onExit);
    dialog.showModal();
  }

  #dismissed() {
    try {
      const at = Number(localStorage.getItem(KjPopup.KEY) || 0);
      return Date.now() - at < 14 * 24 * 60 * 60 * 1000;
    } catch {
      return false;
    }
  }

  #remember() {
    try { localStorage.setItem(KjPopup.KEY, String(Date.now())); } catch {}
  }
}

if (!customElements.get('kj-popup')) customElements.define('kj-popup', KjPopup);
